import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../../Cadenas/Cadenas";
import { catCanales } from "../../Categorias y Estados/catCanales";
import { catFrecuenciaTiempo } from "../../Categorias y Estados/catFrecuenciaTiempo";
import { Tiendas } from "../../Tiendas/Tiendas";
import { Clientes } from "../Clientes";
import { ACTAsignarProductos } from "./ACTAsignarProductos";
import { ACTAsignarServicios } from "./ACTAsignarServicios";
import { ACTQuitarProductos } from "./ACTQuitarProductos";
import { ACTQuitarServicios } from "./ACTQuitarServicios";
import { ClientesConfiguracionTiendasRutaStatusOverrides } from "./ClientesConfiguracionTiendasRutaStatusOverrides";
import { ClientesPorTiendaColumnsOverrides } from "./ClientesPorTiendaColumnsOverrides";

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente ID' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda' }),
        c_frecuenciatiempo_id: new EntityColumn<string>({ name: 'c_frecuenciatiempo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Periodo' }),
        i_minutos_en_tienda: new EntityColumn<number>({ name: 'i_minutos_en_tienda', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Minutos en tienda' }),
        i_cantidad_frecuencia: new EntityColumn<number>({ name: 'i_cantidad_frecuencia', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Frecuencia' }),
        bt_ruta_compartida: new EntityColumn<boolean>({ name: 'bt_ruta_compartida', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Ruta compartida' }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Cadena' }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),
        vc_domicilio_completo: new EntityColumn<string>({ name: 'vc_domicilio_completo', type: 'char', length: 20, flags: c.FK, prompt: 'Domicilio completo' }),
        f_latitud: new EntityColumn<number>({ name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud' }),
        f_longitud: new EntityColumn<number>({ name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clct_brwStandard: {
            name: 'clct_brwStandard', keyMappings: { c_tienda_id: 0 },
            gridColumnsOverrides: ClientesConfiguracionTiendasRutaStatusOverrides
        },
        clct_brwClientesPorTienda: {
            name: 'clct_brwClientesPorTienda', keyMappings: { c_cliente_id: 0 },
            gridColumnsOverrides: ClientesPorTiendaColumnsOverrides
        },
        clct_brwTodas: { name: 'clct_brwTodas', keyMappings: { c_cliente_id: 0, c_tienda_id: 2 } }
    }
)


const lookups = () =>
(
    {
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        }, 'FrecuenciaTiempo': {
            name: 'FrecuenciaTiempo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFrecuenciaTiempo(client, parentKeys)
        }, 'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        }
    }
)

const clientActions = () =>
(
    {
        ACTAsignarProductos: ACTAsignarProductos,
        ACTQuitarProductos: ACTQuitarProductos,
        ACTAsignarServicios: ACTAsignarServicios,
        ACTQuitarServicios: ACTQuitarServicios,
    }
)

export class ClientesConfiguracionTiendasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();
    constructor() {
        super('ClientesConfiguracionTiendas');
    }
}